import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getMasterDataApi} from '../api/master-data-api';
import {masterDataKeys} from '../query-keys';
import type {ObjectRecord, PaginatedResponse} from '../types/master-data-types';

export function useObjectRecords(
  typeId: string,
  params?: {
    search?: string;
    includeArchived?: boolean;
    /** JSONB equality filters, keyed by active field key. */
    filters?: Record<string, string>;
    sortBy?: string;
    sortDir?: 'asc' | 'desc';
    limit?: number;
    offset?: number;
  }
) {
  const tenantId = useRequiredTenantId();
  const api = getMasterDataApi();

  return useQuery<PaginatedResponse<ObjectRecord>>({
    queryKey: masterDataKeys.objectRecords(typeId, tenantId, params),
    queryFn: async () => api.listObjectRecords(typeId, params),
    enabled: Boolean(typeId),
  });
}
